import React from "react";
import ButtonComponent from "../_shared/button/button.component";
import {routerData} from "../../assets/data/router.data";

export default function HomeButtonsComponent(props) {
    return (
        <div
            className="w-full"
            // style={{
            //     backgroundImage: props.type === "home" ? `url(${firstBg})` : 'none',
            //     backgroundSize: "cover",
            //     backgroundPosition: "center center",
            // }}
        >
            <ButtonComponent
                type={props.type}
                data={routerData.home}
                font={props.font}
                border={props.border}
                uber={true}
                deliveroo={true}
                isMobile={props.isMobile}
            />
        </div>
    );
}
